import { AnalyticsStore } from 'bernie-plugin-mobx';

import { ClientLogger } from 'bernie-client';

import { STORE_EVENTS } from '../stores/events/store-events';

import { ApolloLink } from '@apollo/client';

export const PropertyListingQueryApolloAnalyticsLink = (analytics: AnalyticsStore, logger: ClientLogger): ApolloLink =>
  new ApolloLink((operation, forward) =>
    forward(operation).map(response => {
      if (operation.operationName === 'PropertyListingQuery') {
        const analyticsData = response?.extensions?.analytics;
        if (analytics && analyticsData && Array.isArray(analyticsData) && analyticsData.length > 0 && analyticsData[0]) {
          analytics.publishClientSidePayload([analyticsData[0]]);
        } else {
          logger.logEvent(
            STORE_EVENTS.PROPERTY_LISTING_ANALYTICS_PUBLISH_ERROR,
            'Unable to publish analytics for property listings due to missing analytics store or data'
          );
        }
      }

      return response;
    })
  );
